import { i18n as _i18n } from "@lingui/core";
import { useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationForm, CarleadLicensePlateNotRecognized, CarleadMileageFormatted, defaultCarleadSplitFlow, QuestionnaireBoxSelect, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitBuiltDates, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypes, SplitMainTypesSub, SplitManufacturers, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useCreateNormalCarleadForm, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { CarleadProgress, CustomerCounter, ReturningCustomerPopup, TrustPilot, CarleadEmailFieldWithTracking } from '../../../../../components';
import React from 'react';
import { useMinimumMileageValidation } from '../../../../../hooks';
import { carleadQuestionnaireWithBuyCarQuestionPartialFlow } from '../../../../../constants';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadStepCompoundBuyCarConsentCustomerPopup = _ref => {
  let {
    wide = false,
    headlineDesktop = 'carleadCreation.form.mainTitle',
    headlineMobile = 'carleadCreation.form.mainTitle.mobile',
    className = '',
    subheadline = false,
    renderHeader = null,
    showCounterHeadline = false,
    emailSubtitle = false,
    obfuscatedPrice = false,
    emailInfoMessage = false
  } = _ref;
  const flow = {
    ...defaultCarleadSplitFlow,
    ...carleadQuestionnaireWithBuyCarQuestionPartialFlow
  };
  const questionnaireProps = useFormQuestionnaireProps(flow);
  const splitFieldsProps = useSplitFieldsProps();
  const mileageProps = useMinimumMileageValidation();
  const machine = useSplitFieldsFlowService(flow);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useCreateNormalCarleadForm([questionnaireProps, splitFieldsProps, mileageProps]);
  const {
    i18n
  } = useLingui();
  useTrackLanding();
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container step-compound",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: `box gap full-height ${className}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [/*#__PURE__*/_jsx(CarleadLicensePlateNotRecognized, {}), showCounterHeadline ? renderHeader ? renderHeader() : /*#__PURE__*/_jsx(CustomerCounter, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-none d-md-block",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineDesktop)
            }
          }), /*#__PURE__*/_jsx("h1", {
            className: "carlead-creation-form__title d-block d-md-none",
            dangerouslySetInnerHTML: {
              __html: i18n._(headlineMobile)
            }
          }), subheadline && /*#__PURE__*/_jsx("p", {
            className: "carlead-creation-form__subheadline",
            children: i18n._(subheadline)
          })]
        }), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          options: {
            name: 'StepCompound'
          },
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(SplitManufacturers, {}), /*#__PURE__*/_jsx(SplitMainTypes, {}), /*#__PURE__*/_jsx(SplitBuiltDates, {}), /*#__PURE__*/_jsx(SplitBodyTypes, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitFuelType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitHorsePower, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitGearType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitDoorCount, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 2500,
            upperThreshold: 35000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireBoxSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "BUY_CAR",
            isHiddenField: true,
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.buyCar'
            }),
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarYES'
              }),
              value: 'YES'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarNO'
              }),
              value: 'NO'
            }]
          }), /*#__PURE__*/_jsx(CarleadEmailFieldWithTracking, {
            subtitle: emailSubtitle,
            emailInfoMessage: emailInfoMessage
          }), obfuscatedPrice && /*#__PURE__*/_jsx("div", {
            className: "obfuscatedPrice",
            children: /*#__PURE__*/_jsx("img", {
              src: "https://content.wirkaufendeinauto.de/static/car_images/Pixels%20-%20Laman%20Huseynova.gif",
              alt: "Obfuscated Price",
              className: "img-responsive"
            })
          }), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })]
  });
};
export default CarleadStepCompoundBuyCarConsentCustomerPopup;